import styled from 'styled-components'

export const Label = styled.span<{ boldLabel: boolean }>`
  margin-right: ${(props) => props.theme.mp.sm};
  font-weight: ${(props) =>
    props.boldLabel ? props.theme.font.weights.semiBold : props.theme.font.weights.regular};
`

export const RequiredLabel = styled.p`
  color: ${(props) => props.theme.palette.dark};
  font-weight: ${(props) => props.theme.font.weights.light};
  font-size: ${(props) => props.theme.font.sizes.xsmall};
  font-style: italic;
  margin: 0;
  padding: 0;
`

export const InfoWrapper = styled.div<{ isVerticallyCentered?: boolean }>`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: ${(props) => (props.isVerticallyCentered ? `center` : `flex-start`)};
  align-items: flex-start;
  padding-bottom: ${(props) => props.theme.mp.sm};
  padding-top: ${(props) => props.theme.mp.sm};
`

export const LabelTooltipWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`

export const RichTextEditorWrapper = styled.div<{
  maxHeight: string
  minHeight: string
}>`
  display: block;
  & .ql-editor {
    min-height: ${(props) => props.minHeight};
    max-height: ${(props) => props.maxHeight};
  }
`
export const Note = styled.div`
  color: ${({ theme: { palette } }) => palette.muted};
  font-size: ${({
    theme: {
      font: { sizes },
    },
  }) => sizes.small};
  padding-top: 5px;
`
